import React from 'react'
import TopoLines from '#/assets/images/car/topo-lines.svg'
import SvgArrow from '#/assets/images/landing/arrow.svg'
import Button from '#/components/Button'
import Link from '#/components/Link'
import { logEvent } from '#/services/analytics'

interface IntroProps {
  authenticated: boolean
}

export default function Intro(authenticated: IntroProps) {
  const mapPage = {
    href: '/map',
    rel: 'nofollow'
  }
  function logSectionClick(name: string) {
    logEvent('select_content', {
      content_type: 'landing',
      item_id: `${name}_section`
    })
  }

  return (
    <section className='overflow-hidden bg-gradient-to-b from-header to-primary text-center text-white'>
      <div className='relative mx-auto max-w-lg px-4 pb-8  pt-7 text-center sm:px-6 lg:py-[48px]'>
        <TopoLines className='absolute -top-48  hidden rotate-6 pl-96 pt-1 text-primary opacity-30 sm:top-[-40px] sm:block sm:pb-24 sm:pl-24  sm:pt-6 lg:right-[-735px]' />

        <h1 className='-mt-1 mb-4 pt-5 text-3xl font-extrabold tracking-tight text-white sm:text-[40px]'>
          What&apos;s New?
        </h1>
        <div className='h-0.5' />
        <p className='font-thin text-indigo-200 xs:leading-relaxed'>
          Stay up to date with all of the latest additions and improvements
          we&apos;ve made to TopHap.
        </p>

        <div className='flex justify-center pt-4'>
          <Link {...mapPage}>
            <Button
              className='rounded-full bg-secondary px-5 py-2 text-sm font-medium shadow sm:px-6 sm:py-2.5'
              onClick={() => logSectionClick('hero')}
            >
              {authenticated ? 'Try it Out' : 'Get Started'}
              <SvgArrow className='th-arrow-icon ml-2.5 h-5 w-5 rounded-full border border-white' />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  )
}
